<template>
  <mux-player
    v-if="isReady"
    id="residency-audio-player"
    audio
    :no-tooltips="true"
    :playback-id="audio!.mux_playback_id"
    class="w-full"
    :style="playerStyle"
    primary-color="var(--g-fg-primary, black)"
    accent-color="var(--g-button-guest-primary, var(--button-primary-color, blue))"
    secondary-color="var(--g-body-primary, var(--primary-theme-bg-color, white))"
  />
</template>

<script setup lang="ts">
import * as Sentry from '@sentry/vue'
import { computed, onMounted } from 'vue'

import { AudioAssetRead } from '@generated/types'

const props = defineProps<{
  audio: AudioAssetRead | null
}>()

const isReady = computed<boolean>(() => !!props.audio?.mux_playback_id)

// Client-only element registration: `@mux/mux-player` touches window/customElements at import and
// would crash the guest SSR render. The server emits the inert <mux-player> tag and the browser
// upgrades it after this import resolves on hydrate.
onMounted(() => {
  // A failed chunk load leaves the styled box with no player, so surface it rather than fail silently.
  import('@mux/mux-player').catch(err => Sentry.captureException(err))
})

const playerStyle: Record<string, string> = {
  '--seek-backward-button': 'none',
  '--seek-forward-button': 'none',
  '--playback-rate-button': 'none',
  '--media-preview-time-display-display': 'none',
  height: '40px',
  border: '1px solid var(--g-border-color, #6B7280)',
  overflow: 'hidden',
  borderRadius: '0.375rem',
  background: 'var(--g-body-primary, var(--primary-theme-bg-color, white))',
}
</script>
